import React from 'react'
import {BackgroundVideo} from "../../components/backgroundVideo";
import {Meditation1Text, Meditation2Text, Meditation3Text} from "./cybershore_data";
import s from "./text_meditations_styles.module.css"
import {MeditationLink} from "./cybershore_cover";

export default function TextMeditations({index, onExit}) {


    return (<div id={"meditation " + index}>
            
            {/* todo: add background still so it doesn't flash from white while loading*/}
            <BackgroundVideo src={`./toi/meditations/meditationsBG_${index}_loop.mp4`} background_color={"#d7c0c1"} />

            <div id={"column"} className={s.central_column}>

                <BackButton index={index} onPress={onExit} />

                <MeditationAudio index={index}/>

                <TextContent index={index}/>

                <hr/>

                <BackButton index={index} onPress={onExit} />
            </div>


        </div>)
}

function BackButton({index, onPress}) {
    return (<MeditationLink index={index} onPress={onPress} size={"10em"} tooltip={"go back to main page"}/>)
}

function MeditationAudio({index}) {
    return (<div id={`meditation ${index} audio`}>
            <audio
                style={{width: "50%"}}
                src={`./toi/meditations/Meditation_${index}.mp3`}
                controls/>
        </div>)
}

function TextContent({index}) {
    switch (index) {
        case 1:
            return <Meditation1Text/>
        case 2:
            return <Meditation2Text/>
        case 3:
            return <Meditation3Text/>
        case 4:
            console.error("TextMeditations.TextContent: unknown index", index)
    }
}